import styled from '@emotion/styled';

export const ModalShareContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 20;
`;
export const ModalShareBox = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	gap: 2.6rem;
	padding: 2rem;
	overflow-y: auto;
	background-color: #fff;
	width: min(33.4rem, calc(100% - 4rem));
`;
export const ModalShareHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	.title {
		font-size: ${(props) => props.theme.fontSize.sizeXl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		color: #212529;
		line-height: 130%;
		letter-spacing: -0.6px;
	}
`;
export const ModalShareLink = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;
export const ModalShareLinkTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	color: #868e96;
`;
export const CloseButton = styled.button`
	background-color: #fff;
	border: none;
	cursor: pointer;
`;
export const ModalShareContent = styled.div`
	display: flex;
	gap: 1.2rem;
	align-items: center;
	justify-content: center;
`;
export const LogoBox = styled.div`
	max-width: 4.4rem;
	max-height: 4.4rem;
	cursor: pointer;
	img {
		width: 100%;
		height: 100%;
	}
`;
export const ModalShareUrlWrapper = styled.div`
	display: flex;
	height: 4.4rem;
	border-radius: ${(props) => props.theme.borderRadius.control};
	overflow: hidden;
`;
export const UrlBox = styled.input`
	display: flex;
	padding-left: 1.2rem;
	border: 1px solid #adb5bd;
	border-radius: 0;
	height: 100%;
	color: #adb5bd;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	width: 100%;
`;
export const UrlButton = styled.button`
	background-color: #212529;
	color: #fff;
	padding: 0 1.2rem;
	border: none;
	border-radius: 0;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	cursor: pointer;
`;
